var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { Link } from 'react-router';
import { kebabCase } from 'lodash';

import { Button, Pill } from "../../../../Components/UI";
import { Translate } from "../../../../../I18N";


const getPageUrl = (sharedId, title) => `page/${sharedId}/${kebabCase(title)}`;

const EntityViewHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Entity Page");
const TitleHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Title");
const UrlHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "URL");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Action");

const ActionCell = ({ cell }) => {
  const pageUrl = getPageUrl(cell.getValue(), cell.row.original.title);
  const isEntityView = cell.row.original.entityView;

  return (/*#__PURE__*/
    _jsx("div", { className: "flex justify-end gap-2" }, void 0, /*#__PURE__*/
    _jsx(Link, { to: `/${pageUrl}`, target: "_blank", "aria-disabled": isEntityView }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "light", disabled: isEntityView }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "View")
    )
    ), /*#__PURE__*/
    _jsx(Link, { to: `/settings/pages/page/${cell.getValue()}` }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "light" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Edit")
    )
    )
    ));

};

const YesNoPill = ({ cell }) => {
  const { color, label } = cell.getValue() ?
  { color: 'primary', label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Yes") } :
  { color: 'gray', label: /*#__PURE__*/_jsx(Translate, {}, void 0, "No") };

  return /*#__PURE__*/_jsx(Pill, { color: color }, void 0, label);
};

const UrlCell = ({ cell }) => {
  const sharedId = cell.getValue();
  const { title } = cell.row.original;
  const url = `/${getPageUrl(sharedId, title)}`;
  return url;
};

const List = ({ items }) => /*#__PURE__*/
_jsx("ul", { className: "flex flex-wrap max-w-md gap-8 list-disc list-inside" }, void 0,
items.map((item) => /*#__PURE__*/
_jsx("li", {}, item._id, item.title)
)
);


export {
  YesNoPill,
  ActionCell,
  EntityViewHeader,
  TitleHeader,
  UrlHeader,
  ActionHeader,
  UrlCell,
  getPageUrl,
  List };